var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { AppButton } from './app-button';
import { AppDialogTitle } from './app-dialog-title';
import { AppDialogControls } from './app-dialog-controls';
import Draggable from 'react-draggable';
var cls = classNames('app-dialog');
export var AppDialogDefaultProps = {
  disabledActions: [],
  buttonLabels: {},
  closeAction: 'close'
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-family: ", ";\n    font-size: ", ";\n    z-index: 100;\n    overflow: visible;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    border: 1px solid ", ";\n    box-shadow: 0 1px 10px -2px rgba(0, 0, 0, 0.15);\n    border-radius: ", ";\n  "], ["\n    font-family: ", ";\n    font-size: ", ";\n    z-index: 100;\n    overflow: visible;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    border: 1px solid ", ";\n    box-shadow: 0 1px 10px -2px rgba(0, 0, 0, 0.15);\n    border-radius: ", ";\n  "])), theme.FONT('app'), theme.FONT_SIZE(13), theme.COLOR('strong-chrome'), theme.UNIT(2))
});
var TitleStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    box-shadow: 0 1px 0px ", "66;\n    font-size: 1em;\n  "], ["\n    box-shadow: 0 1px 0px ", "66;\n    font-size: 1em;\n  "])), theme.COLOR('strong-chrome'))
});
var BodyStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    background: ", ";\n  "], ["\n    background: ", ";\n  "])), theme.COLOR('canvas'))
});
var ControlsStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    box-shadow: 0 -1px 0px ", "66;\n    cursor: -webkit-grab;\n    user-select: none;\n    &:active {\n      cursor: -webkit-grabbing;\n    }\n  "], ["\n    box-shadow: 0 -1px 0px ", "66;\n    cursor: -webkit-grab;\n    user-select: none;\n    &:active {\n      cursor: -webkit-grabbing;\n    }\n  "])), theme.COLOR('strong-chrome'))
});
var ButtonStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  NAME: 'AppDialog',
  Button: styled(AppButton)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ButtonStyles),
  Container: styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Title: styled(AppDialogTitle)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  Body: styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Controls: styled(AppDialogControls).attrs(cls.attr('controls'))(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ControlsStyles)
};
export var AppDialog = function (props) {
  var componentProps = useComponentProps(My.NAME, AppDialogDefaultProps, props);
  var className = componentProps.className,
    children = componentProps.children,
    title = componentProps.title,
    action = componentProps.action,
    buttonLabels = componentProps.buttonLabels,
    subject = componentProps.subject,
    closeAction = componentProps.closeAction,
    onCloseClick = componentProps.onCloseClick,
    _a = componentProps.loadingActions,
    loadingActions = _a === void 0 ? [] : _a,
    _b = componentProps.disabledActions,
    disabledActions = _b === void 0 ? [] : _b,
    startControls = componentProps.startControls,
    endControls = componentProps.endControls,
    startActions = componentProps.startActions,
    endActions = componentProps.endActions;
  var handleActionButtonClick = function (action) {
    return function (event) {
      var _a;
      event.preventDefault();
      event.stopPropagation();
      (_a = componentProps.onButtonAction) === null || _a === void 0 ? void 0 : _a.call(componentProps, action, event);
    };
  };
  var start = startControls || (startActions === null || startActions === void 0 ? void 0 : startActions.map(function (action) {
    var disabled = disabledActions.includes(action);
    var loading = loadingActions.includes(action);
    return React.createElement(AppButton, {
      key: action,
      label: buttonLabels[action],
      loading: loading,
      onClick: disabled ? undefined : handleActionButtonClick(action),
      disabled: disabled,
      action: action
    });
  }));
  var end = endControls || (endActions === null || endActions === void 0 ? void 0 : endActions.map(function (action) {
    var disabled = disabledActions.includes(action);
    var loading = loadingActions.includes(action);
    return React.createElement(AppButton, {
      key: action,
      label: buttonLabels[action],
      loading: loading,
      onClick: disabled ? undefined : handleActionButtonClick(action),
      disabled: disabled,
      action: action
    });
  }));
  var hasControls = start || end;
  return React.createElement(Draggable, {
    handle: ".".concat(AppDialogTitle.cls.name(), ",").concat(cls.child('controls'))
  }, React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Title, {
    closeAction: closeAction,
    onCloseClick: onCloseClick,
    action: action
  }, subject || title), React.createElement(My.Body, null, children), hasControls && React.createElement(My.Controls, {
    start: start,
    end: end
  })));
};
AppDialog.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;